<template>
  <div class="music-overlay">
    <p class="instructions">Select a song.</p>
    <div class="music-clip-wrapper">
      <div class="music-clip none" v-on:click="select(false)" :class="[!currentMusic ? 'selected' : '' ]">
        <h5>None</h5>
      </div>
      <div class="music-clip" v-for="clip in availableMusic" v-on:click="select(clip)" :key="clip.filename" :class="[currentMusic == clip.id ? 'selected' : '' ]">
        <h5>{{clip.title}}</h5>
        <MusicPreview :clip="clip" />
      </div>
    </div>
  </div>
</template>

<script>
import MusicPreview from "@/components/editor/MusicPreview";

export default {
  name: "Music",
  props: ["music", "editor"],
  components: {
    MusicPreview
  },
  computed: {
    availableMusic: {
      get() {
        const player = this.$parent.$parent;
        const videoJSPlayer = player.$refs.videoJSComponent.videoJSPlayer;
        const duration = videoJSPlayer.duration();
        return this.music.filter(function(clip) {
          let available = false;
          clip.lengths.forEach(function(length) {
            if (duration <= length) {
              available = true;
            }
          })
          return available;
        });
      }
    },
    currentMusic: {
      get() {
        return this.editor.video.musicId;
      },
      set(value) {
        this.editor.video.musicId = value;
      }
    }
  },
  methods: {
    select: function(clip) {
      if (clip !== false) {
        this.currentMusic = clip.id;
      } else {
        this.currentMusic = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  .music-overlay
    display: flex
    color: #FFF
    align-items: center
    justify-content: flex-start
    padding: 0px 30px
    .instructions
      margin-right: 30px
    .music-clip-wrapper
      display: flex
      margin-right: auto
    .music-clip
      cursor: pointer
      display: flex
      flex-wrap: wrap
      align-items: center
      text-align: center
      width: 120px
      height: 90px
      padding: 5px 10px 0px 10px
      box-sizing: border-box
      position: relative
      border-top: 4px solid rgba(255,255,255,0.25)
      &.none {
        padding-top: 0px
      }
      &:after, &:first-of-type:before
        content: ""
        height: 100%
        position: absolute
        width: 1px
        height: 90px
        background: rgba(255,255,255,0.25)
        right: 0px
        bottom: 0px
      &:first-of-type:before
        right: auto
        left: -1px
      &:hover
        border-top: 4px solid rgba(255,255,255,.75)
      &.selected
        border-top: 4px solid #EF4F23
      h5
        width: 100%
        margin: 0px;
        line-height: 15px
</style>
